import { OrganizationTierTypes } from "@/modules/common/types";
import { MixpanelEvents } from "@/modules/analytics/enums";

export enum AnalyticsServiceProviders {
  ALL = "*",
  GOOGLE = "google",
  MIXPANEL = "mixpanel",
  MOENGAGE = "moengage",
}

export interface DefaultEventParams {
  tier?: OrganizationTierTypes;
  device?: "desktop" | "mobile";
  userUid?: string | null;
}

export interface AnalyticsEvent<CustomParams = Record<string, unknown>>
  extends DefaultEventParams {
  name: string;
  customParams?: CustomParams;
  services: AnalyticsServiceProviders[];
}

export interface UserRank {
  rankId: number | null;
  rankTitle: string;
  rankValue: number;
}

export interface UserInfo {
  name?: string | null;
  rank?: UserRank | null;
}

export interface PageViewOptions {
  search?: string;
  hash?: string;
  fullUrl?: string;
  isInitialLoad?: boolean;
}

export type FiltersMemo = Record<string, unknown>;

export enum MixpanelOverviewClickableTargetsEnum {
  EOI = MixpanelEvents.EOI_BUTTON_CLICK,
  RESERVED = MixpanelEvents.RESERVED_BUTTON_CLICK,
  WHEEL_DETAILS = MixpanelEvents.WHEEL_DETAILS_CLICK,
  UNIT_BLOCKED = MixpanelEvents.UNIT_BLOCKED_BUTTON_CLICK,
}

export enum MixpanelOverviewClickableCardsEnum {
  TASKS = MixpanelEvents.TASKS,
  MEETING = MixpanelEvents.MEETING,
  FRESH_LEADS = MixpanelEvents.FRESH_LEADS,
  PRESENTATION = MixpanelEvents.PRESENTATION,
  UNANSWERED_LEADS = MixpanelEvents.UNANSWERED_LEADS,
}

export interface QrCodeEventPayload {
  leadId?: string ;
}

/* ------------------------- Chats & Calls tracking ------------------------- */

export type ChatsCallsSource = "desktop_tab" | "mobile_card";

export type CallSummaryType = "call" | "whatsapp";

export type CallSummaryTab = "overview" | "analysis" | "transcript";

export interface CallSummaryClickedPayload {
  summaryType: CallSummaryType;
  /** Detail sub-tab being viewed; null for WhatsApp (no sub-tabs). */
  tab: CallSummaryTab | null;
  /** Set when summaryType === "call". */
  zoomCallUid?: string;
  /** Set when summaryType === "whatsapp". */
  agentUid?: string;
}
